import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './editorTheme.css';

const TextEditorAll = ({ value, setValue, p_height = '50vh', editorKey, fill = false }) => {
   const handleChange = (_content, _delta, _source, editor) => {
    setValue((prev) => ({ ...prev, [editorKey]: editor.getHTML() }));
  };
  
    const modules = {
      toolbar: [
        [{ 'header': [] }, { 'font': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link'],
        ['clean']                                         
      ],
    };
  
    const formats = [
      'header', 'font', 'list', 'bullet',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'color', 'background', 'align',
      'link'
    ];
  
    return (
        <div
          className={fill ? "rp-quill rp-quill--fill" : "rp-quill"}
          style={fill ? undefined : { "--editor-height": p_height }}
        >
        <ReactQuill
          className={fill ? "h-full min-h-0" : "pb-2"}
          value={value || ""}
          onChange={handleChange}
          modules={modules}
          formats={formats}
        />
        </div>
    );
  };
  
  export default TextEditorAll;